import { SVGProps } from "react";

const ArrowRight = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M0.000253677 9.02344L12.1939 9.02344L8.57288 12.6442L9.97077 14.0588L16.0002 8.02984L9.97077 2.00089L8.57288 3.4155L12.1939 7.03624L0.000253677 7.03624V9.02344Z" />
    </svg>
  );
};

export default ArrowRight;
